export class DefaultSettingsModel {
	defaultBranchId?: string;
	defaultBranchName?: string;
	defaultClientId?: string;
	defaultClientName: string;
	defaultAppScopeUserCreation?: string;
	defaultCMPBranchId?: string;
	defaultCMPBranchName?: string;
}

export class BranchModel {
	id?: string;
	title?: string;
}

export class MilestoneMessageModel {
	id?: string;
	status?: string;
	origin?: string;
	message?: string;
	sendConfirmationToOrigin: boolean;
}
